import React, { FC } from 'react';
import classNames from 'classnames';
import { Link, NavLink } from 'react-router-dom';
import urlJoin from 'url-join';
import { Brand } from '@clearcover/atlas';

import { QUOTE_APP_ROUTE } from 'Shared/constants/routes';

import { applicationSteps } from 'QuoteApp/components';
import { useAppContext } from 'QuoteApp/services/providers';
import styles from './styles.module.css';
import { QuoteNumber } from './QuoteNumber';

type HeaderProps = {
  currentStepIndex: number;
};

export const Header: FC<HeaderProps> = ({ currentStepIndex }) => {
  const { appId, details, isUnauthorized, canNavigate } = useAppContext();

  const barWidth =
    currentStepIndex <= 0
      ? '0%'
      : `${currentStepIndex * (100 / (applicationSteps.length - 1))}%`;
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.brand} data-testid="page-cc-logo">
          <Link to="/quotes">
            <Brand />
          </Link>
        </div>
        <div
          className={classNames(styles.barWrapper, {
            [styles.noShow]: currentStepIndex < 0 || isUnauthorized,
          })}
        >
          <div className={styles.base} />
          <div
            className={classNames(
              styles.progress,
              styles[`progress-${currentStepIndex}`]
            )}
            style={{ width: barWidth }}
          />
          <div className={styles.landmarkContainer}>
            {!isUnauthorized &&
              applicationSteps.map((step, index) => {
                const disabled =
                  !canNavigate ||
                  (step.canNavigateTo && !step.canNavigateTo(details));

                return (
                  <div
                    key={step.path}
                    className={classNames({
                      [styles.disabled]: disabled,
                    })}
                  >
                    <NavLink
                      data-testid={`go-to-step-${step.path}`}
                      className={classNames(styles.baseLandmark, {
                        [styles.active]: currentStepIndex > index,
                        [styles.current]: currentStepIndex === index,
                        [styles.disabled]: disabled,
                      })}
                      activeClassName={styles.current}
                      to={urlJoin(QUOTE_APP_ROUTE, appId, step.path)}
                    />
                  </div>
                );
              })}
          </div>
          <div className={styles.stepNameContainer}>
            {applicationSteps.map((step, index) => (
              <div
                key={step.key}
                className={classNames(styles.stepName, {
                  [styles.active]: currentStepIndex >= index,
                })}
              >
                {step.display}
              </div>
            ))}
          </div>
        </div>
        <div />
        <QuoteNumber />
      </div>
    </div>
  );
};
